import React, { useMemo, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'umi';
import Loading from '@gp/components/Loading';
import DataTime from '@gp/components/DataTime';
import KeyMetrics from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyMetrics';
import FinanceVisualis from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/FinanceVisualis';
import KeyInformationTable from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable';
import useOverviewPageData from '@gp/pages/StudioDashboard/StudioOverall/hooks/useOverviewPageData';
import useAuthChecker from '@gp/pages/StudioDashboard/StudioOverall/hooks/useAuthChecker';
import { reportOperationLog } from '@gp/services/global';
import { context as Context } from '@gp/components/Context';
import { COLLAPSEABLE_LOGO_LIST_MODEL_NAMESPACE } from '@gp/models/collapseableLogoList';
import { getValidDate } from '@gp/utils/common';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';

import '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/index.scss';

const Overveiw: React.FC<IStudioOverallOverviewProps> = (props) => {
  const { style, className } = props;

  const dispatch = useDispatch();

  const [financialOverviewDataTime, setFinancialOverviewDataTime] = useState('');

  const { isLoading: isAccessLoading, accessableModules } = useAuthChecker({
    studioPageKey: 'studio_overview',
    studioId: '',
  });

  const { isLoading: isPageDataLoading, pageData: commonData } = useOverviewPageData();

  const contextData = useMemo<IStudioOverallOverviewContext>(() => {
    return { commonData };
  }, [commonData]);

  // 页面打点
  useEffect(() => {
    if (!isAccessLoading && accessableModules?.length) {
      // @ts-ignore
      reportOperationLog(ALL_REPORT_OPERATION_LOG.STUDIO_OVERALL_OVERVIEW);
    }
  }, [isAccessLoading]);

  // 离开页面时，清楚掉记录icon的展开状态
  useEffect(() => {
    return () => {
      dispatch({ type: `${COLLAPSEABLE_LOGO_LIST_MODEL_NAMESPACE}/clearExpandLogoList` });
    };
  }, []);

  if (isAccessLoading) {
    return (
      <Loading
        style={{ position: 'unset' }}
        innerStyle={{ height: 'calc(100% - 74px)', top: 74 }}
        loading
        loadingBg="#f2f3f5"
      />
    );
  }

  return (
    <Context.Provider value={contextData}>
      <div style={style} className={classnames('dbg-studio-overall-overview', className)}>
        <div className="dbg-studio-overall-overview-flex">
          <div className="dbg-studio-overall-overview-title">Key Metrics</div>
          <DataTime style={{ marginTop: 0 }} dateType="Month" date={commonData?.dataTime} />
        </div>

        {accessableModules?.includes('keymetrics') && (
          <KeyMetrics isLoading={isPageDataLoading} commonData={commonData} />
        )}
        {accessableModules?.includes('overview_list') && <KeyInformationTable isLoading={isPageDataLoading} />}
        {accessableModules?.includes('finance') && (
          <>
            <div className="dbg-studio-overall-overview-flex">
              <div className="dbg-studio-overall-overview-title">Financial Overview</div>
              <DataTime
                style={{ marginTop: 0 }}
                dateType="Month"
                date={getValidDate(financialOverviewDataTime, 'YYYY-MM')}
              />
            </div>
            <FinanceVisualis
              isLoading={isPageDataLoading}
              setFinancialOverviewDataTime={setFinancialOverviewDataTime}
            />
          </>
        )}
      </div>
    </Context.Provider>
  );
};

export default React.memo(Overveiw);
